// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2HqLg","signatureBlock":"Footer_signatureBlock__22NQs","signature":"Footer_signature__2NAbt"};